/**
 * usePrewarmChat
 *
 * Fires a single background POST to /api/chat/prewarm on mount so the
 * server-side preflight cache is warm before the user sends a message.
 * Re-fires when workspaceId or chatId changes.
 */

import { useEffect, useRef } from 'react'

export function usePrewarmChat(options: {
  chatId?: string | null
  workspaceId?: string | null
  spaceId?: string | null
  enabled?: boolean
}) {
  const { chatId, workspaceId, spaceId, enabled = true } = options
  const lastKeyRef = useRef<string>('')

  useEffect(() => {
    if (!enabled) return

    const key = `${chatId ?? ''}:${workspaceId ?? ''}:${spaceId ?? ''}`
    if (key === lastKeyRef.current) return
    lastKeyRef.current = key

    const controller = new AbortController()

    fetch('/api/chat/prewarm', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...(chatId ? { chatId } : {}),
        ...(workspaceId ? { workspaceId } : {}),
        ...(spaceId ? { spaceId } : {})
      }),
      signal: controller.signal
    }).catch(() => {
      // Fire-and-forget — don't disrupt UX on failure
    })

    return () => {
      controller.abort()
    }
  }, [chatId, workspaceId, spaceId, enabled])
}
